<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button></ion-back-button>
    </ion-buttons>
    <ion-title>
      <div class="header-logo">&nbsp;</div>
    </ion-title>
  </ion-toolbar>
  <div class="page-title" translate>MODE.{{modeUC}}.LABEL_LONG</div>
</ion-header>


<ion-content no-bounce class="no-scroll ion-padding">
  <div [innerHTML]="'MODE.'+modeUC+'.MORE_INFO' | translate"></div>
</ion-content>
<ion-footer>
  <ion-button fill="solid" shape="round" expand="block" color="light" (click)="onUseModeClick()" translate>MODE.{{modeUC}}.APPLY</ion-button>
</ion-footer>
